<template>
  <MDBModal v-model="visible" v-show="visible" tabindex="-1" centered @hide="close">
    <MDBCard class="border-0">
      <MDBCardBody class="p-4">
        <MDBCardTitle class="mb-3">{{ $t("global.confirmation.header") }}</MDBCardTitle>
        <MDBCardText class="mb-4">
          {{ $t("global.confirmation.message") }}
          <span v-if="addressLabel" class="d-block mt-2 fw-semibold">{{ addressLabel }}</span>
        </MDBCardText>
        <div class="d-flex justify-content-end gap-2">
          <MDBBtn color="primary" @click="close" :disabled="pending">
            {{ $t("global.buttons.close") }}
          </MDBBtn>
          <MDBBtn color="danger" @click="confirm" :disabled="pending">
            {{ $t("global.buttons.delete") }}
          </MDBBtn>
        </div>
      </MDBCardBody>
    </MDBCard>
  </MDBModal>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import { MDBModal, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn } from "mdb-vue-ui-kit";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  addressLabel: { type: String, default: "" },
  pending: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue", "confirm"]);

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const close = () => {
  emit("update:modelValue", false);
};

const confirm = () => {
  emit("confirm");
};
</script>
